"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return LoaderLifestyleHorizontal;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _graphics = require("../../assets/graphics");
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Container = _styled.default.div("\nsvg {\n    margin: 0 auto;\n    width: 100%;\n    color: #9a8734;\n    -webkit-animation-name: load;\n    -webkit-animation-duration: 1000ms;\n    -webkit-animation-iteration-count: infinite;\n    -webkit-animation-timing-function: linear;\n    -moz-animation-name: load;\n    -moz-animation-duration: 1000ms;\n    -moz-animation-iteration-count: infinite;\n    -moz-animation-timing-function: linear;\n    -ms-animation-name: load;\n    -ms-animation-duration: 1000ms;\n    -ms-animation-iteration-count: infinite;\n    -ms-animation-timing-function: linear;\n    animation-name: load;\n    animation-duration: 1000ms;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n}\n\n#dots #dot1{\n  animation: load 1s infinite;\n}\n\n#dots #dot2{\n  animation: load 1s infinite;\n  animation-delay: 0.2s;\n}\n\n#dots #dot3{\n  animation: load 1s infinite;\n  animation-delay: 0.4s;\n}\n\n@keyframes load{\n  0%{\n    opacity: 0;\n  }\n  50%{\n    opacity: 1;\n  }\n  100%{\n    opacity: 0;\n  }\n");
function LoaderLifestyleHorizontal() {
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(Container, {
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_graphics.HorizontalLoaderX, {})
    });
}
